import React from 'react';
import { connect } from 'react-redux';
import { getAvailability } from '../address/actions';
import _ from 'lodash';
import moment from 'moment';

class DeliveryAvailability extends React.Component {
  componentDidMount() {
    if (!this.props.availability) {
      this.props.getAvailability();
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.address, this.props.address)) {
      this.props.getAvailability();
    }
  }

  _nextAvailability() {
    const { shipping, product } = this.props;
    const availability = this.props.availability || {};
    const vendor = this.props.vendor || {};
    const inServiceArea = shipping || vendor.inside_delivery_zone;

    if (!this._hasAddress()) {
      return (
        <span
          className="clickable"
          onClick={() => this.props.showAvailability()}
        >
          Set delivery address to see local pricing
        </span>
      );
    }

    if (!product.price) {
      const category = product.category || {};
      const categoryURL = category.url;
      const categoryName = category.name;
      const hasCategory = !!categoryURL && !!categoryName;

      return (
        <span className="text-danger">
          This product is currently unavailable in your area.{' '}
          {hasCategory && 'Shop more '}
          {hasCategory && (
            <a href={'/' + categoryURL} className="link-text">
              {categoryName}
            </a>
          )}
        </span>
      );
    }

    if (shipping) {
      if (product.special_order)
        return <span>This product may take 2-3 business days to process.</span>;

      return <span>2-day shipping available</span>;
    }

    if (availability.immediate_delivery) {
      return <span>Get this delivered in 30 minutes</span>;
    }

    if (!inServiceArea)
      return (
        <span
          className="clickable"
          onClick={() => this.props.showAvailability()}
        >
          Delivery isn{"'"}t available at your current address, please enter a
          new delivery address
        </span>
      );

    const hours = vendor.hours || {};
    const nextDate = hours.open;
    const calendar =
      nextDate &&
      moment(nextDate * 1000).calendar(null, {
        sameDay: '[today at] h:mm A',
        nextDay: '[tomorrow at] h:mm A'
      });

    if (calendar) return <span>Next available delivery {calendar}</span>;
  }

  _hasAddress() {
    const address = this.props.address;
    return address && address.lat && address.lng;
  }

  handleClick() {
    this.props.showAvailability();
  }

  render() {
    const nextAvailability = this._nextAvailability();
    if (!nextAvailability) return null;

    return (
      <p>
        <span className="svg-icon svg-icon--delivery delivery-availability__icon" />
        {nextAvailability}
      </p>
    );
  }
}

const ConnectedDeliveryAvailability = connect(
  state => ({
    address: state.address,
    shipping: state.address.shipping,
    availability: state.address.availability,
    vendor: state.address.vendor,
    loadingVendor: state.address.loadingVendor
  }),
  { getAvailability }
)(DeliveryAvailability);

export default ConnectedDeliveryAvailability;



// WEBPACK FOOTER //
// ./shared/components/product/deliveryAvailability.js